import useInquiry from "../../modules/inquiry/hooks";
import React from "react";
import { Button, ButtonGroup, Col } from "shards-react";

function Pagination({ style }) {
  const {
    pageNumber,
    totalLength,
    fetchBypageNumber
  } = useInquiry();
  const postPerPage= 10;
  const pageContainer = [];
  for (let i = 1; i <= Math.ceil(totalLength / postPerPage); i++) {
    pageContainer.push(i);
  }

  return (
    <div style={style} className="w-100">
      <ButtonGroup>
        {pageContainer.map(pg => (
          <Button
            key={pg}
            className="pageination_item"
            onClick={() => {
              fetchBypageNumber(pg);
            }}
            theme={pageNumber === pg ? "primary" : "white"}
          >
            {pg}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
}

export default Pagination;
